import { z } from "zod";

import {
  isoDateTimeSchema,
  moneySchema,
  pageQuerySchema,
  pageSchema,
} from "./common";

/** 商品概览只包含 Shopify 真实数量和更新时间，不表示同步 readiness。 */
export const knowledgeProductsOverviewResponseSchema = z.object({
  shopDomain: z.string().min(1),
  sections: z.object({
    products: z.object({
      count: z.int().nonnegative(),
      updatedAt: isoDateTimeSchema.nullable(),
    }),
  }),
});
export type KnowledgeProductsOverviewResponse = z.infer<
  typeof knowledgeProductsOverviewResponseSchema
>;

/** 商品概览仅读取 Shopify；问答总数来自问答分页响应。 */
export const knowledgeOverviewQuerySchema = z.strictObject({
  section: z.literal("products").optional(),
});

export const knowledgeProductSchema = z.object({
  id: z.string().min(1),
  title: z.string().min(1),
  handle: z.string().min(1),
  imageUrl: z.url().nullable(),
  category: z.string().min(1).nullable(),
  /** 多变体取最低价。 */
  price: moneySchema,
  /** 所有变体库存之和；Shopify 不跟踪库存时为 null。 */
  inventory: z.int().nonnegative().nullable(),
  variantCount: z.int().positive(),
  updatedAt: isoDateTimeSchema,
});

export type KnowledgeProduct = z.infer<typeof knowledgeProductSchema>;

/** `q` 按名称搜索；`category` 为类目筛选，缺省不筛。 */
export const knowledgeProductsQuerySchema = pageQuerySchema
  .extend({
    q: z.string().trim().min(1).optional(),
    category: z.string().min(1).optional(),
  })
  .strict();

export type KnowledgeProductsQuery = z.infer<
  typeof knowledgeProductsQuerySchema
>;

/** `GET /api/knowledge/products`。`categories` 是本店全部类目，供筛选器用。 */
export const knowledgeProductsResponseSchema = pageSchema(
  knowledgeProductSchema,
).extend({
  categories: z.array(z.string().min(1)),
});

export type KnowledgeProductsResponse = z.infer<
  typeof knowledgeProductsResponseSchema
>;

/** MyQA Online 问答只读文本，ID 沿用管理端真实问答主键。 */
export const knowledgeQuestionSchema = z.object({
  id: z.string().regex(/^[1-9]\d*$/),
  question: z.string(),
  answer: z.string(),
});
export const knowledgeQuestionsQuerySchema = pageQuerySchema
  .extend({
    cursor: z.string().min(1).max(2048).optional(),
  })
  .strict();
export const knowledgeQuestionsResponseSchema = pageSchema(
  knowledgeQuestionSchema,
).extend({
  total: z.int().nonnegative(),
});
export type KnowledgeQuestionsResponse = z.infer<
  typeof knowledgeQuestionsResponseSchema
>;
